import styled from 'styled-components';

interface ContainerProps {
  minHeight?: string;
  maxHeight?: string;
  background?: string;
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  height: 100%;
  min-height: ${props => (props.minHeight ? props.minHeight : '100vh')};
  max-height: ${props => (props.maxHeight ? props.maxHeight : '100vh')};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props =>
    props.background ? props.background : props.theme?.colors?.bg || '#f4f5f7'};
`;
